//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./user.d.ts" />

import * as $ from "skir-client";
import * as x_meeting_stage from "./meeting_stage.js";
import * as x_package from "./package.js";

// -----------------------------------------------------------------------------
// enum SeatType
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SeatType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum CallVisibility
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CallVisibility extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct User.Preferences
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `User.Preferences.Mutable`.
 *
 * @alias User.Preferences
 */
class User_Preferences extends $._FrozenBase {}

function initUser_Preferences(target, initializer) {
  target.disableEmailNotifications = initializer.disableEmailNotifications ?? false;
  target.botInvitedByDefault = initializer.botInvitedByDefault ?? false;
  target.timezone = initializer.timezone ?? "";
  target.voiceIdentificationOptIn = initializer.voiceIdentificationOptIn ?? false;
  target.disablePrepEmailNotifications = initializer.disablePrepEmailNotifications ?? false;
  target.skipInternalMeetings = initializer.skipInternalMeetings ?? false;
  target.disableSlackPrepNotifications = initializer.disableSlackPrepNotifications ?? false;
  target.disableSlackRecapNotifications = initializer.disableSlackRecapNotifications ?? false;
  target.preferredLanguage = initializer.preferredLanguage ?? "";
  target.disablePrepEmailNotificationsInternal = initializer.disablePrepEmailNotificationsInternal ?? false;
  target.disablePrepSlackNotificationsInternal = initializer.disablePrepSlackNotificationsInternal ?? false;
  target.disableRecapEmailNotificationsInternal = initializer.disableRecapEmailNotificationsInternal ?? false;
  target.disableRecapSlackNotificationsInternal = initializer.disableRecapSlackNotificationsInternal ?? false;
  target.disablePrepEmailNotificationsExternal = initializer.disablePrepEmailNotificationsExternal ?? false;
  target.disablePrepSlackNotificationsExternal = initializer.disablePrepSlackNotificationsExternal ?? false;
  target.disableRecapEmailNotificationsExternal = initializer.disableRecapEmailNotificationsExternal ?? false;
  target.disableRecapSlackNotificationsExternal = initializer.disableRecapSlackNotificationsExternal ?? false;
}

// -----------------------------------------------------------------------------
// struct User
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `User.Mutable`. */
export class User extends $._FrozenBase {}

function initUser(target, initializer) {
  target.id = initializer.id ?? "";
  target.email = initializer.email ?? "";
  target.admin = initializer.admin ?? false;
  target.accountAdmin = initializer.accountAdmin ?? false;
  target.firstName = initializer.firstName ?? "";
  target.lastName = initializer.lastName ?? "";
  target.accountId = initializer.accountId ?? BigInt(0);
  target.unregistered = initializer.unregistered ?? false;
  target.phoneNumber = initializer.phoneNumber ?? "";
  target.jobTitle = initializer.jobTitle ?? "";
  target.organization = initializer.organization ?? "";
  target.marketingConsent = initializer.marketingConsent ?? false;
  target.preferences = User_Preferences.create(initializer.preferences ?? User_Preferences.DEFAULT);
  target.zoomOauthConnection = initializer.zoomOauthConnection ? ZoomOAuthConnection.create(initializer.zoomOauthConnection) : null;
  target.managerId = initializer.managerId ?? "";
  target.packageTier = x_package.PackageTier.create(initializer.packageTier ?? x_package.PackageTier.UNKNOWN);
  target.isKnowledgeContributor = initializer.isKnowledgeContributor ?? false;
  target.seatType = SeatType.create(initializer.seatType ?? SeatType.UNKNOWN);
  target.callVisibility = CallVisibility.create(initializer.callVisibility ?? CallVisibility.UNKNOWN);
}

// -----------------------------------------------------------------------------
// struct UserState.Meeting
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `UserState.Meeting.Mutable`.
 *
 * @alias UserState.Meeting
 */
class UserState_Meeting extends $._FrozenBase {}

function initUserState_Meeting(target, initializer) {
  target.id = initializer.id ?? "";
  target.stage = x_meeting_stage.MeetingStage.create(initializer.stage ?? x_meeting_stage.MeetingStage.DEFAULT);
  target.joinedAt = initializer.joinedAt ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct UserState
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UserState.Mutable`. */
export class UserState extends $._FrozenBase {}

function initUserState(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.meetings = $._toFrozenArray(
    initializer.meetings || [],
    UserState_Meeting.create,
  );
}

// -----------------------------------------------------------------------------
// struct UserSocketSessions.Session
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `UserSocketSessions.Session.Mutable`.
 *
 * @alias UserSocketSessions.Session
 */
class UserSocketSessions_Session extends $._FrozenBase {}

function initUserSocketSessions_Session(target, initializer) {
  target.sessionId = initializer.sessionId ?? "";
  target.connectionTime = initializer.connectionTime ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct UserSocketSessions
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UserSocketSessions.Mutable`. */
export class UserSocketSessions extends $._FrozenBase {}

function initUserSocketSessions(target, initializer) {
  target.sessions = $._toFrozenArray(
    initializer.sessions || [],
    UserSocketSessions_Session.create,
  );
}

// -----------------------------------------------------------------------------
// enum CalendarProvider
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CalendarProvider extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum CalendarOAuthClient
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CalendarOAuthClient extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum CalendarIntegrationStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CalendarIntegrationStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct UserCalendarIntegration
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UserCalendarIntegration.Mutable`. */
export class UserCalendarIntegration extends $._FrozenBase {}

function initUserCalendarIntegration(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.accessToken = initializer.accessToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
  target.provider = CalendarProvider.create(initializer.provider ?? CalendarProvider.UNKNOWN);
  target.oauthClient = CalendarOAuthClient.create(initializer.oauthClient ?? CalendarOAuthClient.UNKNOWN);
  target.status = CalendarIntegrationStatus.create(initializer.status ?? CalendarIntegrationStatus.UNKNOWN);
}

// -----------------------------------------------------------------------------
// enum MailboxProvider
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class MailboxProvider extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum MailboxIntegrationStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class MailboxIntegrationStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct UserMailboxIntegration
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UserMailboxIntegration.Mutable`. */
export class UserMailboxIntegration extends $._FrozenBase {}

function initUserMailboxIntegration(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.provider = MailboxProvider.create(initializer.provider ?? MailboxProvider.UNKNOWN);
  target.emailAddress = initializer.emailAddress ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.accessToken = initializer.accessToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
  target.syncCursor = initializer.syncCursor ?? "";
  target.status = MailboxIntegrationStatus.create(initializer.status ?? MailboxIntegrationStatus.UNKNOWN);
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.lastSyncAt = initializer.lastSyncAt ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct ZoomOAuthConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ZoomOAuthConnection.Mutable`. */
export class ZoomOAuthConnection extends $._FrozenBase {}

function initZoomOAuthConnection(target, initializer) {
  target.zoomOauthConnectionId = initializer.zoomOauthConnectionId ?? "";
  target.zoomUserId = initializer.zoomUserId ?? "";
  target.connectedAt = initializer.connectedAt ?? $.Timestamp.UNIX_EPOCH;
  target.zoomAppToken = initializer.zoomAppToken ?? "";
}

// -----------------------------------------------------------------------------
// enum Impersonation
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class Impersonation extends $._EnumBase {}

function createValueOfImpersonation(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "impersonated_user_id": {
      return value;
    }
    case "account_id_override": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "user.skir",
  [
    {
      kind: "enum",
      ctor: SeatType,
      name: "SeatType",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "RECORDING",
          number: 1,
        },
        {
          name: "LISTENER",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: CallVisibility,
      name: "CallVisibility",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "MINE",
          number: 1,
        },
        {
          name: "DIRECT_REPORTS",
          number: 2,
        },
        {
          name: "REPORTING_TREE",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: User_Preferences,
      initFn: initUser_Preferences,
      name: "Preferences",
      parentCtor: User,
      fields: [
        {
          name: "disable_email_notifications",
          property: "disableEmailNotifications",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "bot_invited_by_default",
          property: "botInvitedByDefault",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "timezone",
          property: "timezone",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "voice_identification_opt_in",
          property: "voiceIdentificationOptIn",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_prep_email_notifications",
          property: "disablePrepEmailNotifications",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "skip_internal_meetings",
          property: "skipInternalMeetings",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_slack_prep_notifications",
          property: "disableSlackPrepNotifications",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_slack_recap_notifications",
          property: "disableSlackRecapNotifications",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "preferred_language",
          property: "preferredLanguage",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "disable_prep_email_notifications_internal",
          property: "disablePrepEmailNotificationsInternal",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_prep_slack_notifications_internal",
          property: "disablePrepSlackNotificationsInternal",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_recap_email_notifications_internal",
          property: "disableRecapEmailNotificationsInternal",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_recap_slack_notifications_internal",
          property: "disableRecapSlackNotificationsInternal",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_prep_email_notifications_external",
          property: "disablePrepEmailNotificationsExternal",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_prep_slack_notifications_external",
          property: "disablePrepSlackNotificationsExternal",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_recap_email_notifications_external",
          property: "disableRecapEmailNotificationsExternal",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "disable_recap_slack_notifications_external",
          property: "disableRecapSlackNotificationsExternal",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: User,
      initFn: initUser,
      name: "User",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "email",
          property: "email",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "admin",
          property: "admin",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "account_admin",
          property: "accountAdmin",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "first_name",
          property: "firstName",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_name",
          property: "lastName",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "unregistered",
          property: "unregistered",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "phone_number",
          property: "phoneNumber",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "job_title",
          property: "jobTitle",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "organization",
          property: "organization",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "marketing_consent",
          property: "marketingConsent",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "preferences",
          property: "preferences",
          number: 13,
          type: {
            kind: "record",
            ctor: User_Preferences,
          },
          mutableGetter: "mutablePreferences",
        },
        {
          name: "zoom_oauth_connection",
          property: "zoomOauthConnection",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: ZoomOAuthConnection,
            },
          },
        },
        {
          name: "manager_id",
          property: "managerId",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "package_tier",
          property: "packageTier",
          number: 16,
          type: {
            kind: "record",
            ctor: x_package.PackageTier,
          },
        },
        {
          name: "is_knowledge_contributor",
          property: "isKnowledgeContributor",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "seat_type",
          property: "seatType",
          number: 18,
          type: {
            kind: "record",
            ctor: SeatType,
          },
        },
        {
          name: "call_visibility",
          property: "callVisibility",
          number: 19,
          type: {
            kind: "record",
            ctor: CallVisibility,
          },
        },
      ],
      removedNumbers: [
        4,
      ],
    },
    {
      kind: "struct",
      ctor: UserState_Meeting,
      initFn: initUserState_Meeting,
      name: "Meeting",
      parentCtor: UserState,
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage",
          property: "stage",
          number: 1,
          type: {
            kind: "record",
            ctor: x_meeting_stage.MeetingStage,
          },
          mutableGetter: "mutableStage",
        },
        {
          name: "joined_at",
          property: "joinedAt",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: UserState,
      initFn: initUserState,
      name: "UserState",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meetings",
          property: "meetings",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: UserState_Meeting,
            },
            keyChain: "id",
          },
          mutableGetter: "mutableMeetings",
          indexable: {
            searchMethod: "searchMeetings",
            keyFn: (v) => v.id,
          },
        },
      ],
      removedNumbers: [
        1,
        2,
      ],
    },
    {
      kind: "struct",
      ctor: UserSocketSessions_Session,
      initFn: initUserSocketSessions_Session,
      name: "Session",
      parentCtor: UserSocketSessions,
      fields: [
        {
          name: "session_id",
          property: "sessionId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connection_time",
          property: "connectionTime",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: UserSocketSessions,
      initFn: initUserSocketSessions,
      name: "UserSocketSessions",
      fields: [
        {
          name: "sessions",
          property: "sessions",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: UserSocketSessions_Session,
            },
            keyChain: "session_id",
          },
          mutableGetter: "mutableSessions",
          indexable: {
            searchMethod: "searchSessions",
            keyFn: (v) => v.sessionId,
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CalendarProvider,
      name: "CalendarProvider",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "GOOGLE",
          number: 1,
        },
        {
          name: "MICROSOFT",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: CalendarOAuthClient,
      name: "CalendarOAuthClient",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "LEGACY",
          number: 1,
        },
        {
          name: "QUBI",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: CalendarIntegrationStatus,
      name: "CalendarIntegrationStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ACTIVE",
          number: 1,
        },
        {
          name: "NEEDS_REAUTH",
          number: 2,
        },
      ],
    },
    {
      kind: "struct",
      ctor: UserCalendarIntegration,
      initFn: initUserCalendarIntegration,
      name: "UserCalendarIntegration",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "access_token",
          property: "accessToken",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "provider",
          property: "provider",
          number: 4,
          type: {
            kind: "record",
            ctor: CalendarProvider,
          },
        },
        {
          name: "oauth_client",
          property: "oauthClient",
          number: 5,
          type: {
            kind: "record",
            ctor: CalendarOAuthClient,
          },
        },
        {
          name: "status",
          property: "status",
          number: 6,
          type: {
            kind: "record",
            ctor: CalendarIntegrationStatus,
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: MailboxProvider,
      name: "MailboxProvider",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "GOOGLE",
          number: 1,
        },
        {
          name: "MICROSOFT",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: MailboxIntegrationStatus,
      name: "MailboxIntegrationStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ACTIVE",
          number: 1,
        },
        {
          name: "NEEDS_REAUTH",
          number: 2,
        },
        {
          name: "DISABLED",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: UserMailboxIntegration,
      initFn: initUserMailboxIntegration,
      name: "UserMailboxIntegration",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "provider",
          property: "provider",
          number: 1,
          type: {
            kind: "record",
            ctor: MailboxProvider,
          },
        },
        {
          name: "email_address",
          property: "emailAddress",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "access_token",
          property: "accessToken",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "sync_cursor",
          property: "syncCursor",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 7,
          type: {
            kind: "record",
            ctor: MailboxIntegrationStatus,
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "last_sync_at",
          property: "lastSyncAt",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ZoomOAuthConnection,
      initFn: initZoomOAuthConnection,
      name: "ZoomOAuthConnection",
      fields: [
        {
          name: "zoom_oauth_connection_id",
          property: "zoomOauthConnectionId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "zoom_user_id",
          property: "zoomUserId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "connected_at",
          property: "connectedAt",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "zoom_app_token",
          property: "zoomAppToken",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: Impersonation,
      createValueFn: createValueOfImpersonation,
      name: "Impersonation",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "NONE",
          number: 1,
        },
        {
          name: "impersonated_user_id",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id_override",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
      ],
    },
  ]
);
